export default {"src":"/_next/static/media/ddos.1def55dd.svg","height":45,"width":63,"blurWidth":0,"blurHeight":0};